import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import survey from '../../actions/survey';
import { Row, Spin, Col, Icon } from 'antd';
import Button from '../Button/index';
import AnswerType from '../Answer/index';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin/>;

class Step extends Component{
	constructor(props) {
		super(props);
		this.state = {
			selectedVariant: null,
			currentStep: props.currentStep,
			options: null,
		};
		this.onVariantChanged = this.onVariantChanged.bind(this);
		this.onAnswer = this.onAnswer.bind(this);
	}
	
	onVariantChanged = (selectedVariant, options) => {
		this.setState({ selectedVariant, options });
	};
	onAnswer = () => {
		const { selectedVariant, options } = this.state;
		const { currentStep, auth } = this.props;
		this.setState({ selectedVariant: null, options: null });
		survey.answer(currentStep, selectedVariant, options, auth.uid);
	};
	
	render() {
		const { questions, answers, survey } = this.props;
		const { selectedVariant, currentStep, options } = this.state;
		
		if (!(questions && answers && survey) || !survey[currentStep]) {
			return (
				<Row type='flex' justify='center' align='middle' className='Spin'>
					<Spin indicator={antIcon}/>
				</Row>
			);
		}
		
		const questionId = survey[currentStep].questId;
		
		return (
			<div className='Step'>
				<Row type='flex' justify='center' align='middle'>
					<Col xs={18} sm={16} md={14}>
						<AnswerType
							questionId={questionId}
							onVariantChanged={this.onVariantChanged}
							value={selectedVariant}
						/>
					</Col>
					<Button
						type="primary"
						disabled={selectedVariant == null && options == null}
						onClick={this.onAnswer}>
						<FormattedMessage {...messages.button} />
					</Button>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = ({ survey: { answers, questions, survey, currentStep }, user: { auth } }) => {
	return {
		currentStep, answers, questions, survey, auth
	};
};

export default connect(mapStateToProps)(Step);



// WEBPACK FOOTER //
// ./src/components/SurveyStep/SurveyStep.js